import { Config, httpPost } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSubmitOtp = async ({
  intentId,
  otp,
  intentOtpData,
  lang,
}: {
  intentId: string;
  otp: string;
  intentOtpData: Record<string, unknown>;
  lang: string;
}) => {
  if (
    "otp_data" in intentOtpData &&
    typeof intentOtpData.otp_data === "object"
  ) {
    const paymentResponse = await httpPost<PaymentApiResponse>(
      `otp-authorization/?lang=${lang}`,
      { ...intentOtpData.otp_data, otp }
    );
    return formatPaymentResponse(paymentResponse);
  }

  const paymentResponse = await httpPost<PaymentApiResponse>(
    `${import.meta.env.VITE_API_BASE}/api/${
      Config.apiVersion
    }/providers/alrajhi_mokafaa/otp/${intentId}/?lang=${lang}`,
    { otp },
    true
  );

  return formatPaymentResponse(paymentResponse);
};
